



























































































































































































































































































































































import { Component, Vue, PropSync } from "vue-property-decorator";
import DateField, {
  formatCountOfNights,
} from "@/components/misc/DateField.vue";
import NumericPicker from "@/components/misc/NumericPicker.vue";
import DeferredAutocompleteWrapper from "@/components/misc/DeferredAutocompleteWrapper.vue";
import { DefferedAutocompleteItem } from "@/components/misc/DeferredAutocomplete.vue";
import { ListModel } from "@/shared/models/listModel";
import { City } from "@/shared/models/city";
import { Category } from "@/shared/models/category";
import { Action, Getter } from "vuex-class";
import { PropertyType } from "@/shared/models/propertyType";
import { AmenityView } from "@/shared/models/amenities";
import PriceInput from "@/components/calendar/inputs/PriceInput.vue";
import { FinancialSettingsType } from "@/store/modules/financial";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";

export interface AvailabilitySearchFormModel {
  period: string[];
  numberOfUnits?: number;
  numberOfAdults?: number;
  numberOfChildren?: number;
  numberOfBedrooms?: number;
  numberOfBathrooms?: number;
  fromPrice?: number;
  toPrice?: number;
  distanceToBeach?: number;
  distanceToCityCenter?: number;
  childAges: (number | null)[];

  cityId?: number;
  propertyName?: string;
  propertyTypes?: number[];
  categories?: number[];
  amenities?: number[];

  includeOnlyWholeProperties?: boolean;
  ignoreRestrictions?: boolean;
  ignoreUnitTypeCount?: boolean;
  includeSpecialOffers?: boolean;
}

@Component({
  components: {
    DateField,
    NumericPicker,
    DeferredAutocompleteWrapper,
    PriceInput,
    CurrencyDisplay,
    NumericInputImproved
  },
})
export default class AvailabilitySearchForm extends Vue {
  @PropSync("searchModel") internalModel?: AvailabilitySearchFormModel;

  @Action("codebooks/refreshPropertyTypes") refreshPropertyTypes?: () => Promise<void>;
  @Getter("codebooks/propertyTypes") propertyTypes?: PropertyType[];
  
  @Action("codebooks/refreshCategories") refreshCategories?: () => Promise<void>;
  @Getter("codebooks/categories") categories?: Category[];

  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;
  
  @Action("codebooks/refreshAmenitiesAndGroups")
  refreshAmenitiesAndGroups?: () => Promise<void>;
  @Getter("codebooks/amenities") amenities?: AmenityView[];

  @Getter("language/language") language?: string;

  async created() {
    const promises = [];

    if ((this.propertyTypes?.length ?? 0) === 0 && this.refreshPropertyTypes) {
      promises.push(this.refreshPropertyTypes());
    }
    if ((this.categories?.length ?? 0) === 0 && this.refreshCategories) {
      promises.push(this.refreshCategories());
    }
    if (
      (this.amenities?.length ?? 0) === 0 && this.refreshAmenitiesAndGroups) {
      promises.push(this.refreshAmenitiesAndGroups());
    }
    if (this.storedSettings?.workingCurrency && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }

    await Promise.all(promises);
  }

  get dateRangeText() {
    if (!this.internalModel) return "";
    return formatCountOfNights(this)(this.internalModel.period);
  }

  get sortedPropertyTypes(){
    // copied over to a temp array to avoid mutating the array stored in the getter 
    // as that triggers an update on other components hooked to the same getter potentially causing an infinite update loop
    const tempArray = [...this.propertyTypes ?? []];
    return tempArray.sort((a,b) => this.$t(a.textResourceKey).toString().localeCompare(this.$t(b.textResourceKey).toString(), this.language));
  }

  get currencyId(){
    return this.storedSettings?.workingCurrency.id;
  }

  get uniqueAmenities(){
    const uniqueAmenities = [] as AmenityView[];
    // Push only unique values.
    this.amenities?.forEach(x => {
      if(!uniqueAmenities.map(uT => uT.textResourceKey).includes(x.textResourceKey)){
        uniqueAmenities.push(x);
      }
    })
    
    return uniqueAmenities.sort((a,b) => this.$t(a.textResourceKey).toString().localeCompare(this.$t(b.textResourceKey).toString(), this.language)) ?? []; 
  }

  updateChildAges() {
    if (!this.internalModel) return;

    if (
      !this.internalModel.numberOfChildren ||
      this.internalModel.numberOfChildren <= 0
    ) {
      this.internalModel.childAges = [];
      return;
    }

    while (
      this.internalModel.childAges.length < this.internalModel.numberOfChildren
    ) {
      this.internalModel.childAges.push(0);
    }

    while (
      this.internalModel.childAges.length > this.internalModel.numberOfChildren
    ) {
      this.internalModel.childAges.pop();
    }

    this.$emit("updateRestrictions");
  }

  citiesFetch(val: { search: string }): Promise<DefferedAutocompleteItem[]> {
    return this.axios
      .get<ListModel<City>>("codebooks/cities", {
        params: {
          $orderby: "name",
          name: val.search,
        },
      })
      .then(({ data }) =>
        data.result.map((x) => ({
          id: x.id,
          text: x.name,
        }))
      );
  }

  ignoreUnitTypeCountSwitchKey = 0;
  numberOfUnitsChanged(value: number | null) {
    if (!this.internalModel) return;

    if (value == null) {
      this.internalModel.ignoreUnitTypeCount = true;
      this.ignoreUnitTypeCountSwitchKey += 1;
    }

    this.$emit("updateRestrictions");
  }

  get rules() {
    return {
      Required: (value: any) =>
        !!value || value === 0 || this.$t("Validation.Required"),
      NoNegativeNumbers: (value: number) =>
        value == null ||
        value == undefined ||
        value >= 0 ||
        this.$t("Validation.MustBePositive"),
      WholeNumbersOnly: (value: number) =>
        value == null ||
        value == undefined ||
        value % 1 == 0 ||
        this.$t("Validation.MustBeWholeNumber"),
    };
  }
}
